<template>
  <!-- Success Modal -->
  <div
    id="successModal"
    class="modal fade"
    tabindex="-1"
    role="dialog"
    aria-labelledby="successModalLabel"
    aria-hidden="true"
  >
    <div
      class="modal-dialog"
      role="document"
    >
      <div class="modal-content">
        <div class="modal-header">
          <h5
            id="successModalLabel"
            class="modal-title"
          >
            {{ $t('label.modal.SUCCESS_MODAL_LABEL') }}
          </h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          />
        </div>
        <div class="modal-body">
          <div class="alert alert-success">
            <p id="successModalMsg" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Modal } from 'bootstrap'
export default {
  components: {
  },
  props: {
  },
  data () {
    return {
    }
  },
  created () {
  },
  mounted() {
    // Listen for the modal being hidden
    var successModal = document.getElementById('successModal')
    successModal.addEventListener('hidden.bs.modal', () => {
      this.onModalClose()
    })
  },
  beforeUnmount() {
    // Cleanup the event listener to prevent memory leaks
    var successModal = document.getElementById('successModal')
    successModal.addEventListener('hidden.bs.modal', () => {
      this.onModalClose()
    })
  },

  methods: {
    showSuccess (msg) {
      let successModal = new Modal(document.getElementById('successModal'))
      successModal.show()
      document.getElementById('successModalMsg').innerHTML = msg
    },

    onModalClose() {
      this.$router.push({ name: 'request-list' })
    }
  }
}
</script>

<style scoped lang="scss">

</style>
